export const CELL_HEIGHT = 150;
export const IMAGE_HEIGHT = 110;
export const LINE_CHART_HEIGHT = 104;
export const PIE_CHART_HEIGHT = 204;
